export default {
  citySelected: 'citySelected',
  eventOnLanguageChanged: 'onLanguageChanged',
  langSelected: 'langSelected',
  countryConstantsSelected: 'countryConstantsSelected',
  countrySelected: 'countrySelected'
}



// WEBPACK FOOTER //
// ./src/store/keys.js